import { CookieConsentConfig } from "vanilla-cookieconsent";

import { COOKIES_DOMAIN } from "../../../constants";

const pluginConfig: CookieConsentConfig = {
  mode: "opt-out",
  cookie: {
    name: "cc_archway",
    domain: COOKIES_DOMAIN,
  },
  categories: {
    necessary: {
      enabled: true,
      readOnly: true,
    },
    analytics: {
      enabled: true,
      autoClear: {
        cookies: [
          {
            name: /^(_ga)/,
          },
          {
            name: "_gid",
          },
        ],
      },
    },
    marketing: { enabled: true },
    features: { enabled: true },
  },
  onFirstConsent: () => {},
  onConsent: () => {},
  onChange: () => {},
  language: {
    default: "en",
    translations: {
      en: {
        consentModal: {
          title: "Cookie Settings",
          description:
            'By clicking “Accept All Cookies”, you agree to the storing of cookies on your device to enhance site navigation, analyze site usage and assist in our marketing efforts. <a href="https://www.archway.finance/cookie-policy" target="_blank">More info</a>',
          acceptAllBtn: "Accept All Cookies",
          acceptNecessaryBtn: "Deny All Cookies",
          showPreferencesBtn: "Cookie Settings",
        },
        preferencesModal: {
          title: "Cookie Settings",
          acceptAllBtn: "Accept All Cookies",
          acceptNecessaryBtn: "Deny All Cookies",
          savePreferencesBtn: "Save Settings",
          closeIconLabel: "Close",
          sections: [
            {
              description:
                'By clicking “Accept All Cookies”, you agree to the storing of cookies on your device to enhance site navigation, analyze site usage and assist in our marketing efforts. <a href="https://www.archway.finance/cookie-policy" target="_blank">More info</a>',
            },
            {
              title: "Strictly Necessary (Always Active)",
              description:
                "Cookies required to enable basic website functionality.",
              linkedCategory: "necessary",
            },
            {
              title: "Marketing",
              description:
                "Cookies used to deliver advertising that is more relevant to you and your interests.",
              linkedCategory: "marketing",
            },
            {
              title: "Personalization",
              description:
                "Cookies allowing the website to remember choices you make (such as your user name, language, or the region you are in).",
              linkedCategory: "features",
            },
            {
              title: "Analytics",
              description:
                "Cookies helping understand how this website performs, how visitors interact with the site, and whether there may be technical issues.",
              linkedCategory: "analytics",
            },
          ],
        },
      },
    },
  },
};

export default pluginConfig;
